<template>
  <div>
    <b-tabs
      active-nav-item-class="text-success"
      v-model="tabIndex"
    >
      <b-tab
        v-if="
          $store.state.authentication.roles.indexOf(
            FUEL_TANKS_INFO_READ_ROLE
          ) != -1
        "
        v-bind:title="
          $store.state.localization.data.mainPage.fuelTanks.tableLabel
        "
      >
        <FuelTanksTable
          v-bind:fuelTanksInfo="fuelTanksInfo"
          v-bind:fuelTanks="fuelTanks"
          v-bind:fuelDepos="fuelDepos"
          v-on:fuelTankClickedEvent="onFuelTankClicked"
        ></FuelTanksTable>
      </b-tab>
      <b-tab
        v-if="
          $store.state.authentication.roles.indexOf(
            FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE
          ) != -1
        "
        v-bind:title="accountingSystemTableLabel"
      >
        <FuelTanksAccountingSystemTable
          v-bind:fuelTanksInfo="fuelTanksInfoAccountingSystem"
          v-bind:fuelTanks="fuelTanks"
          v-on:fuelTankClickedEvent="onFuelTankAccountingSystemClicked"
        ></FuelTanksAccountingSystemTable>
      </b-tab>
      <b-tab
       v-if="
          $store.state.authentication.roles.indexOf(
            FUEL_TANKS_MAP_READ_ROLE
          ) != -1
        "
        v-bind:title="
          $store.state.localization.data.mainPage.fuelTanks.mapLabel
        "
      >
        <FuelTanksMap
          ref="fuelTanksMapRef"
          v-bind:fuelTanksInfo="fuelTanksInfoMap"
          v-bind:fuelTanksInfoAccountingSystem="fuelTanksInfoAccountingSystem"
          v-bind:fuelTanks="fuelTanks"
        ></FuelTanksMap>
      </b-tab>
      <b-tab
        v-if="
          $store.state.authentication.roles.indexOf(
            FUEL_FLOW_METERS_INFO_READ_ROLE
          ) != -1
        "
        v-bind:title="
          $store.state.localization.data.mainPage.fuelFlowMeters.tableLabel
        "
      >
        <FuelFlowMetersTable></FuelFlowMetersTable>
      </b-tab>
      <b-tab
        v-bind:title="
          $store.state.localization.data.mainPage.fuelTanks.dashboardLabel
        "
      >
        <FuelTanksDashboard
          v-bind:fuelTanksInfo="fuelTanksInfo"
          v-bind:fuelTanks="fuelTanks"
        ></FuelTanksDashboard>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import FuelTanksMap from "../MapFuelTanks/MapFuelTanksPage.vue";
import FuelTanksTable from "../ListFuelTanks/ListFuelTanks.vue";
import FuelTanksAccountingSystemTable from "../ListAccountingSystemFuelTanks/FuelTanksAccountingSystemPage.vue";
import FuelFlowMetersTable from "../../FuelFlowMeters/ListFuelFlowMeters/ListFuelFlowMeters.vue";
import FuelTanksDashboard from "../FuelTanksDashboard/FueTanksDashboard.vue";

import { fuelTankService, roleService } from "../../../services";

export default {
  name: "FuelTanks",
  components: {
    FuelTanksMap,
    FuelTanksTable,
    FuelTanksAccountingSystemTable,
    FuelFlowMetersTable,
    FuelTanksDashboard
  },
  data() {
    return {
      tabIndex: 0,
      timeout: 60 * 1000,
      fuelTanksInfo: null,
      fuelTanksInfoAccountingSystem: null,
      fuelFlowMeters: null,
      fuelFlowMetersInfo: null,
      FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE:
        roleService.FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE,
      FUEL_TANKS_INFO_READ_ROLE: roleService.FUEL_TANKS_INFO_READ_ROLE,
      FUEL_TANKS_MAP_READ_ROLE: roleService.FUEL_TANKS_MAP_READ_ROLE,
      FUEL_FLOW_METERS_INFO_READ_ROLE: roleService.FUEL_FLOW_METERS_INFO_READ_ROLE,
    };
  },
  props: {
    fuelTanks: Array,
    fuelDepos: Array
  },
  computed: {
    fuelTanksInfoMap() {
      if (
        this.$store.state.authentication.roles.indexOf(
          this.FUEL_TANKS_INFO_READ_ROLE
        ) == -1 &&
        this.$store.state.authentication.roles.indexOf(
          this.FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE
        ) != -1
      ) {
        return this.fuelTanksInfoAccountingSystem;
      }

      return this.fuelTanksInfo;
    },
    accountingSystemTableLabel() {
      if (
        this.$store.state.authentication.roles.indexOf(
          this.FUEL_TANKS_INFO_READ_ROLE
        ) != -1 &&
        this.$store.state.authentication.roles.indexOf(
          this.FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE
        ) != -1
      ) {
        return this.$store.state.localization.data.mainPage.fuelTanks
          .accountingSystemTableLabel;
      } else {
        return this.$store.state.localization.data.mainPage.fuelTanks
          .tableLabel;
      }
    },
  },
  async created() {
    if (
      this.$store.state.authentication.roles.indexOf(this.FUEL_TANKS_INFO_READ_ROLE) !=
      -1
    ) {
      await this.getFuelTanksInfo();
    }

    if (
      this.$store.state.authentication.roles.indexOf(
        this.FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE
      ) != -1
    ) {
      await this.getFuelTanksAccountingSystemInfo();
    }
  },
  methods: {
    async getFuelTanksInfo() {
      const fuelTanksResponse = await fuelTankService.getFuelTanksInfo();

      if (fuelTanksResponse.isSuccess) {
        this.fuelTanksInfo = fuelTanksResponse.data.fuelTanksInfo;
      }

      setTimeout(this.getFuelTanksInfo.bind(this), this.timeout);
    },
    async getFuelTanksAccountingSystemInfo() {
      const fuelTanksResponse = await fuelTankService.getFuelTanksAccountingSystemInfo();

      if (!fuelTanksResponse.isSuccess) {
        return;
      }

      this.fuelTanksInfoAccountingSystem = fuelTanksResponse.data.fuelTanksInfo;

      setTimeout(
        this.getFuelTanksAccountingSystemInfo.bind(this),
        this.timeout
      );
    },
    onFuelTankClicked(vehicleId) {
      this.$refs.fuelTanksMapRef.showFuelTank(vehicleId);

      if (
        this.$store.state.authentication.roles.indexOf(
          this.FUEL_TANKS_INFO_READ_ROLE
        ) != -1 &&
        this.$store.state.authentication.roles.indexOf(
          this.FUEL_TANKS_INFO_ACCOUNTING_SYSTEM_READ_ROLE
        ) != -1
      ) {
        this.tabIndex = 2;
      } else {
        this.tabIndex = 1;
      }
    },
    onFuelTankAccountingSystemClicked(vehicleId) {
      this.$refs.fuelTanksMapRef.showFuelTank(vehicleId);
      this.tabIndex = 1;
    },
  },
};
</script>

